import React, { FunctionComponent } from "react";
import { Button, Container, Icon, Stack, Text, useTheme } from "@bookingcom/bui-react";
import styles from "./PostBookingCheckoutFooter.desktop.module.css";
import { mcn } from "../../../utils/mergeClassnames";
import ConditionalWrap from "../../atoms/ConditionalWrap";
import { LockClosedIcon } from "@bookingcom/bui-assets-react/streamline/index.js";

interface Props {
  errorMessage?: string;
  onClickPrimary: () => void;
  onClickSecondary?: () => void;
  labelPrimary: string;
  labelSecondary?: string;
  isPrimaryEnabled?: boolean;
  isPrimaryLoading?: boolean;
  isSecondaryEnabled?: boolean;
  isSecondaryLoading?: boolean;
  sticky?: boolean;
  showBorder?: boolean;
  pbFastTrackModalContent?: React.ReactElement;
}

const PostBookingCheckoutFooterDesktop: FunctionComponent<Props> = (props) => {
  const theme = useTheme();
  const {
    errorMessage,
    onClickPrimary,
    labelPrimary,
    onClickSecondary,
    labelSecondary,
    isPrimaryEnabled = true,
    isPrimaryLoading = false,
    isSecondaryEnabled = true,
    isSecondaryLoading = false,
    sticky = false,
    showBorder = true,
    pbFastTrackModalContent = undefined
  } = props;

  return (
    <div
      className={mcn(styles.wrapper, sticky && styles.wrapperSticky)}
      style={{ borderTop: showBorder ? `solid 1px ${theme.colors.color_border_alt}` : "none" }}
    >
      <Container
        className={styles.container}
        fullWidth
        mixin={!pbFastTrackModalContent ? { paddingBlockStart: 4, paddingBlockEnd: 4 } : undefined}
      >
        {errorMessage && (
          <div className={styles.errorMessage}>
            <Text variant="body_2">{errorMessage}</Text>
          </div>
        )}
        <ConditionalWrap
          condition={!!pbFastTrackModalContent}
          wrap={(children) => (
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              {children}
            </Stack>
          )}
        >
          {pbFastTrackModalContent}
          <Stack direction="row" className={styles.buttonGroup} justifyContent="end">
            <Button
              icon={pbFastTrackModalContent && <Icon svg={LockClosedIcon} size="medium" />}
              size="large"
              variant="primary"
              loading={isPrimaryLoading}
              disabled={!isPrimaryEnabled}
              onClick={onClickPrimary}
              text={labelPrimary}
              loadingAriaLabel=""
            />
            {labelSecondary && onClickSecondary && (
              <Button
                size="large"
                variant="tertiary"
                loading={isSecondaryLoading}
                disabled={!isSecondaryEnabled}
                onClick={onClickSecondary}
                text={labelSecondary}
                loadingAriaLabel=""
              />
            )}
          </Stack>
        </ConditionalWrap>
      </Container>
    </div>
  );
};
export default PostBookingCheckoutFooterDesktop;
